/**
 * require-if-visible
 * Require fields only if they are visible
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */


; (function($){

    "use strict";

    $(function(){
        /**
         * Define require if visible as a function
         *
         * @return void
         */
        var requireIfVisible = function (){
            // Collapsed group of elements
            var $groups = $('.collapse.require-if-visible');

            $groups.each(function(index, group){
                var $group = $(group);
                // Collect all required elements within a group
                var $elements = $group.find(':input[data-required], :radio[data-required]');
                // If the Group is initially Visible
                if ($group.is(':visible')){
                    $elements.attr('required', 'required');
                } else {
                    $elements.removeAttr('required');
                }

                // When group is collapsed
                $group.on('hide.bs.collapse ', function () {
                    $elements.removeAttr('required');
                });

                // When group begins to be shown
                $group.on('show.bs.collapse ', function () {
                    $elements.attr('required', 'required');
                })
            });
        }

        /**
         * Append even to any input within document
         */
        $(document).ready(requireIfVisible)

        /**
         * Append even to any input within document... after the modal is loaded
         */
        $('#remote').on('loaded.bs.modal', requireIfVisible);

    })
})(window.jQuery);
